import { ListContainer, StyledListItem } from "../styles";

import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { Logo } from "components/logo";
import { gaClickCallback } from "helpers/common";
import { HEADER_LINKS } from "../header.constants";

export const DesktopHeader = ({ setOpenLogin, setOpenRegister }) => {
  const handleUserRedirect = (route, redirect) => {
    const element = document.getElementById(route);

    if (redirect) return (window.location.href = redirect);

    if (element)
      element?.scrollIntoView({
        behavior: "smooth",
      });
  };

  return (
    <Grid container p="30px 80px" flexWrap="nowrap" alignItems="center" justifyContent="center" gap="40px">
      <Logo />
      <Grid container justifyContent="space-between">
        <ListContainer>
          {HEADER_LINKS.map(({ title, route, redirect }, index) => (
            <StyledListItem onClick={() => handleUserRedirect(route, redirect)} key={index}>
              {title}
            </StyledListItem>
          ))}
        </ListContainer>

        <ListContainer sx={{ gap: "24px" }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              gaClickCallback({
                label: "Login",
                callback: () => setOpenLogin(true),
              });
            }}
          >
            Login
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              gaClickCallback({
                label: "Sign up",
                callback: () => setOpenRegister(true),
              });
            }}
          >
            Sign up
          </Button>
        </ListContainer>
      </Grid>
    </Grid>
  );
};
